import React from 'react'
import Link from 'gatsby-link'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import { confetti, logo, grid, dots, symbolOverview, symbol, settings, setting, shapeIcon, shapes, depth } from '../images/home'

const IndexPage = () => (
  <main className="home">
    <header className="header padding-xxl">
      <div className="container-md">
        <div className="grid yg center text-center">
          <div className="col-12">
            <img src={logo} className="logo margin-xs-bottom" alt="Confetti logo" />
            <h1>Confetti</h1>
            <h4>for Adobe XD</h4>
            <p className="streamer center margin-m-bottom">Generate gorgeous confetti patterns in 1 click within Adobe XD.</p>
            <div className="buttons margin-xl-bottom">
              <OutboundLink
                className="btn primary lg"
                href="https://exchange.adobe.com/apps/cc/d2f4d13f/confetti"
              >
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <g fill="none" fillRule="evenodd">
                    <circle cx="16" cy="16" r="16" fill="#FFFFFF" fillRule="nonzero" />
                    <path fill="#FF007E" fillRule="nonzero" d="M14.4746456,18.3952784 L14.4746456,10.032875 C14.4746456,9.1862915 15.1609371,8.5 16.0075206,8.5 C16.8541041,8.5 17.5403956,9.1862915 17.5403956,10.032875 L17.5403956,18.3802372 L19.429711,16.4909218 C20.0154974,15.9051354 20.9652449,15.9051354 21.5510313,16.4909218 C22.1368178,17.0767083 22.1368178,18.0264557 21.5510313,18.6122422 L17.1689139,22.9943595 C17.1020392,23.0612343 17.0304209,23.1204745 16.9551422,23.1720801 C16.6943434,23.3774655 16.3652417,23.5 16.0075206,23.5 C15.6899075,23.5 15.3948559,23.4034025 15.150142,23.2379836 C15.035958,23.172972 14.9284904,23.0917639 14.8310861,22.9943595 L10.4489687,18.6122422 C9.86318225,18.0264557 9.86318225,17.0767083 10.4489687,16.4909218 C11.0347551,15.9051354 11.9845026,15.9051354 12.570289,16.4909218 L14.4746456,18.3952784 Z" />
                  </g>
                </svg>
                <div>
                  Install Now
                  <span>v3.1.2</span>
                </div>
              </OutboundLink>
            </div>
          </div>
        </div>
        <div className="video-container">
          <iframe src="https://www.youtube-nocookie.com/embed/l1jJIG9xCzQ?controls=0" frameBorder="0" allowFullScreen></iframe>
        </div>
      </div>
    </header>

    <section className="features padding-xxl-top">
      <div className="container-md">
        <div className="grid yg settings-feature padding-xxl align-middle">
          <div className="col-6 text-content">
            <div className="feature-icon margin-s-bottom">
              <img src={shapeIcon} alt="Shapes illustration" />
            </div>
            <h2 className="light">Tweak your settings</h2>
            <p className="light narrow">
              Everything about how your confetti looks is customizable. What to you want to randomize? Opacity, rotation, scale?
            </p>
          </div>

          <div className="col-6">
            <img src={settings} className="feature-illu settings-image" alt="Settings overview" />
          </div>
        </div>

        <div className="grid yg shapes-feature padding-xxl padding-xxxl-bottom align-middle">
          <div className="col-6">
            <img src={shapes} className="shapes-image feature-illu" alt="Shapes example" />
          </div>

          <div className="col-6 text-content">
            <div className="feature-icon margin-s-bottom">
              <img src={shapeIcon} alt="Shapes illustration" />
            </div>
            <h2 className="light">Use your own custom shapes</h2>
            <p className="light">Keep generating to find the perfect compostion of your shapes.</p>
          </div>
        </div>

        <div className="grid yg depth-feature padding-xxl center text-center">
          <div className="blur-bg"></div>
          <div className="col-12">
            <div className="content margin-xxl-bottom">
              <div className="feature-icon margin-s-bottom">
                <img src={depth} alt="Depth illustration" />
              </div>
              <h2 className="light">Depth of Field</h2>
              <p className="light narrow">
                Love to work with parallax and have a depth of field? Look no further as we added the feature to mimic the blur of camera depth of field.
              </p>
            </div>
          </div>
        </div>

        <div className="grid yg symbol-feature padding-xxl align-middle">
          <div className="col-6">
            <img src={symbolOverview} className="symbol-image feature-illu" alt="Symbol example" />
          </div>

          <div className="col-6 text-content">
            <div className="feature-icon margin-s-bottom">
              <img src={symbol} alt="Symbol illustration" />
            </div>
            <h2 className="light">Symbol all the things!</h2>
            <p className="light">Use symbols to easily make changes to the look of your confetti.</p>
          </div>
        </div>

        <div className="grid yg padding-xxl cta-row center text-center">
          <div className="col-12">
            <p className="light streamer margin-l-bottom">Generate gorgeous confetti patterns in 1 click within Adobe XD.</p>

            <div className="cta">
              <OutboundLink
                className="btn primary lg"
                href="https://exchange.adobe.com/apps/cc/d2f4d13f/confetti"
              >
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <g fill="none" fillRule="evenodd">
                    <circle cx="16" cy="16" r="16" fill="#FFFFFF" fillRule="nonzero" />
                    <path fill="#FF007E" fillRule="nonzero" d="M14.4746456,18.3952784 L14.4746456,10.032875 C14.4746456,9.1862915 15.1609371,8.5 16.0075206,8.5 C16.8541041,8.5 17.5403956,9.1862915 17.5403956,10.032875 L17.5403956,18.3802372 L19.429711,16.4909218 C20.0154974,15.9051354 20.9652449,15.9051354 21.5510313,16.4909218 C22.1368178,17.0767083 22.1368178,18.0264557 21.5510313,18.6122422 L17.1689139,22.9943595 C17.1020392,23.0612343 17.0304209,23.1204745 16.9551422,23.1720801 C16.6943434,23.3774655 16.3652417,23.5 16.0075206,23.5 C15.6899075,23.5 15.3948559,23.4034025 15.150142,23.2379836 C15.035958,23.172972 14.9284904,23.0917639 14.8310861,22.9943595 L10.4489687,18.6122422 C9.86318225,18.0264557 9.86318225,17.0767083 10.4489687,16.4909218 C11.0347551,15.9051354 11.9845026,15.9051354 12.570289,16.4909218 L14.4746456,18.3952784 Z" />
                  </g>
                </svg>
                <div>
                  Install Now
                  <span>v3.0.2</span>
                </div>
              </OutboundLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js